export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'div', 
              name: 'Seção Tempo',
              attributes: { class: 'section section-full' },
              components: [
                {
                  type: 'containerTimeLine2', 
                },
                
              ],
              styles: `
             .section.section-full{
              padding:0; 
             }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};